import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Custom handcrafted SVG icons - bold geometric, editorial style
const MapIcon = ({ size = 20, active = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6L9 3L15 6L21 3V18L15 21L9 18L3 21V6Z" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.8" fill="none" strokeLinejoin="round"/>
    <line x1="9" y1="3" x2="9" y2="18" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.4" strokeDasharray="2 2"/>
    <line x1="15" y1="6" x2="15" y2="21" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.4" strokeDasharray="2 2"/>
    <circle cx="12" cy="11" r="2" fill={active ? '#F5A623' : 'currentColor'} opacity="0.9"/>
    <path d="M12 9V7" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const CalcIcon = ({ size = 20, active = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="3" width="16" height="18" rx="1" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.8" fill="none"/>
    <rect x="7" y="6" width="10" height="4" rx="0.5" fill={active ? '#F5A623' : 'currentColor'} opacity="0.25"/>
    <rect x="7" y="6" width="10" height="4" rx="0.5" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.2" fill="none"/>
    <circle cx="8.5" cy="14" r="1" fill={active ? '#F5A623' : 'currentColor'}/>
    <circle cx="12" cy="14" r="1" fill={active ? '#F5A623' : 'currentColor'}/>
    <circle cx="15.5" cy="14" r="1" fill={active ? '#F5A623' : 'currentColor'}/>
    <circle cx="8.5" cy="17.5" r="1" fill={active ? '#F5A623' : 'currentColor'}/>
    <circle cx="12" cy="17.5" r="1" fill={active ? '#F5A623' : 'currentColor'}/>
    <rect x="14" y="16.5" width="3" height="2" rx="0.3" fill={active ? '#F5A623' : 'currentColor'} opacity="0.7"/>
  </svg>
);

const AccountIcon = ({ size = 20, active = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3Z" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.8" fill="none"/>
    <path d="M5 20C5 16.7 8.1 14 12 14C15.9 14 19 16.7 19 20" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.8" strokeLinecap="round" fill="none"/>
    <path d="M9 7.5L10.5 9L14 5.5" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ActivityIcon = ({ size = 20, active = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="2,14 6,8 10,16 14,5 18,12 22,9" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <line x1="2" y1="20" x2="22" y2="20" stroke={active ? '#F5A623' : 'currentColor'} strokeWidth="1.2" opacity="0.4"/>
    <circle cx="6" cy="8" r="1.5" fill={active ? '#F5A623' : 'currentColor'} opacity="0.7"/>
    <circle cx="14" cy="5" r="1.5" fill={active ? '#F5A623' : 'currentColor'} opacity="0.7"/>
  </svg>
);

const SearchIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" strokeWidth="2" fill="none"/>
    <line x1="15.5" y1="15.5" x2="21" y2="21" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square"/>
    <line x1="8" y1="10.5" x2="13" y2="10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <line x1="10.5" y1="8" x2="10.5" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

const CloseIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="5" y1="5" x2="19" y2="19" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
    <line x1="19" y1="5" x2="5" y2="19" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
  </svg>
);

const HamburgerIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square"/>
    <line x1="3" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square"/>
    <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square"/>
  </svg>
);

const CheckMarkIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="4,13 9,18 20,6" stroke="#F5A623" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Custom NordPass wordmark logo - brutalist editorial style
const NordPassLogo = ({ compact = false }) => (
  <svg
    viewBox="0 0 120 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={compact ? 90 : 120}
    height={compact ? 27 : 36}
    aria-label="NordPass"
  >
    {/* N letterform - bold geometric */}
    <path d="M4 6H8V30H4V6Z" fill="#EEF0F2"/>
    <path d="M4 6L16 24V6H20V30H16L4 12V30H4" fill="#EEF0F2"/>
    <path d="M4 6H20V30H16V12L4 30H4V6Z" fill="#EEF0F2"/>
    {/* Aurora accent bar under N */}
    <rect x="4" y="31" width="16" height="2" fill="#F5A623"/>
    {/* ORDPASS text */}
    <text
      x="26"
      y="26"
      fontFamily="'Impact', 'Arial Black', sans-serif"
      fontSize="22"
      fontWeight="900"
      fill="#EEF0F2"
      letterSpacing="-0.5"
    >ORDPASS</text>
    {/* Diagonal slash accent */}
    <line x1="22" y1="6" x2="24" y2="30" stroke="#4A90E2" strokeWidth="1.5" opacity="0.6"/>
  </svg>
);

const iconMap = {
  Map: MapIcon,
  Calculator: CalcIcon,
  User: AccountIcon,
  Activity: ActivityIcon,
};

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems = [
    {
      label: 'Veikart',
      path: '/nordic-map-dashboard',
      icon: 'Map',
      tooltip: 'Sanntids trafikk og veimeldinger'
    },
    {
      label: 'Bomkalkulator',
      path: '/toll-calculator',
      icon: 'Calculator',
      tooltip: 'Beregn bomkostnader for din rute'
    },
    {
      label: 'Min konto',
      path: '/nord-pass-subscription-portal',
      icon: 'User',
      tooltip: 'Abonnement og fakturering'
    },
    {
      label: 'Min aktivitet',
      path: '/user-profile-activity-dashboard',
      icon: 'Activity',
      tooltip: 'Kommentarhistorikk og engasjement'
    }
  ];

  const isActiveRoute = (path) => location?.pathname === path;

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      navigate(`/search-results-page?q=${encodeURIComponent(searchQuery?.trim())}`);
      setSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <>
      {/* Top accent stripe - aurora colors */}
      <div style={{ height: '3px', background: 'linear-gradient(90deg, #4A90E2 0%, #F5A623 40%, #2EC4A0 70%, #4A90E2 100%)', position: 'sticky', top: 0, zIndex: 51 }} />
      <header
        style={{
          position: 'sticky',
          top: '3px',
          zIndex: 50,
          background: '#0D1929',
          borderBottom: '2px solid rgba(74,144,226,0.25)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.5)'
        }}
      >
        {/* Subtle grid texture overlay */}
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.03,
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 20px, rgba(238,240,242,0.8) 20px, rgba(238,240,242,0.8) 21px), repeating-linear-gradient(90deg, transparent, transparent 20px, rgba(238,240,242,0.8) 20px, rgba(238,240,242,0.8) 21px)',
          pointerEvents: 'none'
        }} />

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px' }}>

            {/* Logo */}
            <Link
              to="/nordic-map-dashboard"
              style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none', flexShrink: 0 }}
              aria-label="NordPass Hjem"
            >
              {/* Handcrafted N mark */}
              <div style={{
                width: '36px', height: '36px', background: 'linear-gradient(135deg, #1A3A6B 0%, #0D1929 100%)',
                border: '2px solid #4A90E2', display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'relative', flexShrink: 0,
                clipPath: 'polygon(0 0, 100% 0, 100% 85%, 85% 100%, 0 100%)'
              }}>
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                  {/* Bold N letterform */}
                  <path d="M5 4H8V20H5V4Z" fill="#EEF0F2"/>
                  <path d="M5 4L14 16V4H17V20H14L5 8V20H5" fill="#EEF0F2"/>
                  <path d="M5 4H17V20H14V8L5 20H5V4Z" fill="#EEF0F2"/>
                  {/* Orange accent dot */}
                  <circle cx="19" cy="5" r="2" fill="#F5A623"/>
                </svg>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                <span style={{
                  fontFamily: "'Impact', 'Arial Black', sans-serif",
                  fontSize: '18px',
                  fontWeight: 900,
                  color: '#EEF0F2',
                  letterSpacing: '-0.5px',
                  textTransform: 'uppercase'
                }}>NORDPASS</span>
                <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '9px',
                  color: '#4A90E2',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  marginTop: '1px'
                }}>VEISYSTEM · NO</span>
              </div>
            </Link>

            {/* Diagonal divider */}
            <div style={{ display: 'none', alignItems: 'center', margin: '0 20px' }} className="md-divider">
              <svg width="12" height="40" viewBox="0 0 12 40" fill="none">
                <line x1="10" y1="2" x2="2" y2="38" stroke="rgba(74,144,226,0.3)" strokeWidth="1.5"/>
              </svg>
            </div>

            {/* Desktop Nav */}
            <nav
              style={{ display: 'none', alignItems: 'center', gap: '4px', flex: 1, justifyContent: 'center' }}
              className="desktop-nav"
              aria-label="Primær navigasjon"
            >
              {navigationItems?.map((item) => {
                const NavIcon = iconMap?.[item?.icon];
                const active = isActiveRoute(item?.path);
                return (
                  <Link
                    key={item?.path}
                    to={item?.path}
                    title={item?.tooltip}
                    aria-current={active ? 'page' : undefined}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 16px',
                      textDecoration: 'none',
                      position: 'relative',
                      color: active ? '#F5A623' : 'rgba(238,240,242,0.65)',
                      fontFamily: "'Inter', sans-serif",
                      fontSize: '13px',
                      fontWeight: active ? 700 : 500,
                      letterSpacing: active ? '0.3px' : '0',
                      textTransform: 'uppercase',
                      transition: 'color 0.2s, transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                      borderBottom: active ? '2px solid #F5A623' : '2px solid transparent',
                      paddingBottom: '6px',
                    }}
                    className="nav-spring"
                  >
                    {NavIcon && <NavIcon size={18} active={active} />}
                    <span>{item?.label}</span>
                  </Link>
                );
              })}
            </nav>

            {/* Right side: search + mobile toggle */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {/* Search */}
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }} className="search-area">
                {searchOpen ? (
                  <form onSubmit={handleSearchSubmit} style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      autoFocus
                      type="text"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e?.target?.value)}
                      placeholder="Søk..."
                      style={{
                        background: 'rgba(74,144,226,0.08)',
                        border: '1.5px solid rgba(74,144,226,0.4)',
                        borderRight: 'none',
                        padding: '7px 14px',
                        fontFamily: "'Inter', sans-serif",
                        fontSize: '13px',
                        color: '#EEF0F2',
                        outline: 'none',
                        width: '180px',
                        letterSpacing: '0.2px'
                      }}
                    />
                    <button
                      type="submit"
                      style={{
                        background: '#F5A623',
                        border: '1.5px solid #F5A623',
                        padding: '7px 12px',
                        cursor: 'pointer',
                        color: '#0D1929',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      className="btn-spring"
                    >
                      <SearchIcon size={15} />
                    </button>
                    <button
                      type="button"
                      onClick={() => { setSearchOpen(false); setSearchQuery(''); }}
                      style={{
                        background: 'rgba(238,240,242,0.05)',
                        border: '1.5px solid rgba(238,240,242,0.1)',
                        borderLeft: 'none',
                        padding: '7px 10px',
                        cursor: 'pointer',
                        color: 'rgba(238,240,242,0.4)',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <CloseIcon size={14} />
                    </button>
                  </form>
                ) : (
                  <button
                    onClick={() => setSearchOpen(true)}
                    aria-label="Åpne søk"
                    style={{
                      background: 'none',
                      border: '1.5px solid rgba(74,144,226,0.2)',
                      padding: '8px',
                      cursor: 'pointer',
                      color: 'rgba(238,240,242,0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      transition: 'all 0.2s'
                    }}
                    className="search-btn btn-spring"
                  >
                    <SearchIcon size={18} />
                  </button>
                )}
              </div>

              {/* Mobile hamburger */}
              <button
                onClick={toggleMobileMenu}
                aria-label="Åpne meny"
                aria-expanded={isMobileMenuOpen}
                style={{
                  background: 'none',
                  border: '1.5px solid rgba(74,144,226,0.2)',
                  padding: '8px',
                  cursor: 'pointer',
                  color: '#EEF0F2',
                  display: 'flex',
                  alignItems: 'center'
                }}
                className="mobile-toggle btn-spring"
              >
                {isMobileMenuOpen ? <CloseIcon size={22} /> : <HamburgerIcon size={22} />}
              </button>
            </div>
          </div>
        </div>

        {/* Inline CSS for responsive show/hide */}
        <style>{`
          @media (min-width: 768px) {
            .desktop-nav { display: flex !important; }
            .mobile-toggle { display: none !important; }
            .md-divider { display: flex !important; }
          }
          @media (max-width: 767px) {
            .search-area { display: none !important; }
          }
          .search-btn:hover { color: #EEF0F2 !important; border-color: rgba(74,144,226,0.5) !important; }
          .desktop-nav a:hover { color: #EEF0F2 !important; }
        `}</style>
      </header>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 49,
            background: 'rgba(13,25,41,0.85)',
            backdropFilter: 'blur(4px)'
          }}
          role="dialog"
          aria-modal="true"
          aria-label="Mobilmeny"
        >
          <div
            style={{
              position: 'absolute', inset: 0
            }}
            onClick={closeMobileMenu}
            aria-hidden="true"
          />

          <nav
            style={{
              position: 'relative',
              height: '100%',
              width: '100%',
              maxWidth: '320px',
              background: '#0D1929',
              borderRight: '2px solid rgba(74,144,226,0.25)',
              overflowY: 'auto'
            }}
            aria-label="Mobilnavigasjon"
          >
            {/* Mobile header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '20px 24px',
              borderBottom: '1px solid rgba(74,144,226,0.2)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '40px', height: '40px',
                  background: 'linear-gradient(135deg, #1A3A6B 0%, #0D1929 100%)',
                  border: '2px solid #4A90E2',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  clipPath: 'polygon(0 0, 100% 0, 100% 85%, 85% 100%, 0 100%)'
                }}>
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
                    <path d="M5 4H8V20H5V4Z" fill="#EEF0F2"/>
                    <path d="M5 4H17V20H14V8L5 20H5V4Z" fill="#EEF0F2"/>
                    <circle cx="19" cy="5" r="2" fill="#F5A623"/>
                  </svg>
                </div>
                <div>
                  <div style={{
                    fontFamily: "'Impact', 'Arial Black', sans-serif",
                    fontSize: '16px', fontWeight: 900, color: '#EEF0F2',
                    letterSpacing: '-0.5px', textTransform: 'uppercase'
                  }}>NORDPASS</div>
                  <div style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: '8px', color: '#4A90E2',
                    letterSpacing: '2px', textTransform: 'uppercase', fontWeight: 600
                  }}>VEISYSTEM · NO</div>
                </div>
              </div>
              <button
                onClick={closeMobileMenu}
                aria-label="Lukk meny"
                style={{
                  background: 'none', border: '1.5px solid rgba(238,240,242,0.1)',
                  padding: '8px', cursor: 'pointer', color: 'rgba(238,240,242,0.6)',
                  display: 'flex', alignItems: 'center'
                }}
                className="btn-spring"
              >
                <CloseIcon size={20} />
              </button>
            </div>

            {/* Aurora accent bar */}
            <div style={{ height: '2px', background: 'linear-gradient(90deg, #4A90E2, #F5A623, #2EC4A0)' }} />

            {/* Nav items */}
            <div style={{ padding: '16px 0' }}>
              {navigationItems?.map((item, idx) => {
                const NavIcon = iconMap?.[item?.icon];
                const active = isActiveRoute(item?.path);
                return (
                  <Link
                    key={item?.path}
                    to={item?.path}
                    onClick={closeMobileMenu}
                    aria-current={active ? 'page' : undefined}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '16px 24px',
                      textDecoration: 'none',
                      color: active ? '#F5A623' : 'rgba(238,240,242,0.7)',
                      borderLeft: active ? '3px solid #F5A623' : '3px solid transparent',
                      background: active ? 'rgba(245,166,35,0.06)' : 'transparent',
                      transition: 'all 0.15s, transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1)'
                    }}
                    className="nav-spring"
                  >
                    {/* Number label */}
                    <span style={{
                      fontFamily: "'Impact', sans-serif",
                      fontSize: '11px',
                      color: active ? '#F5A623' : 'rgba(74,144,226,0.4)',
                      fontWeight: 900,
                      minWidth: '18px'
                    }}>0{idx + 1}</span>

                    {NavIcon && <NavIcon size={22} active={active} />}

                    <div style={{ flex: 1 }}>
                      <div style={{
                        fontFamily: "'Inter', sans-serif",
                        fontSize: '14px',
                        fontWeight: active ? 700 : 500,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>{item?.label}</div>
                      <div style={{
                        fontFamily: "'Inter', sans-serif",
                        fontSize: '11px',
                        color: 'rgba(238,240,242,0.35)',
                        marginTop: '2px',
                        letterSpacing: '0.2px'
                      }}>{item?.tooltip}</div>
                    </div>

                    {active && <CheckMarkIcon size={18} />}
                  </Link>
                );
              })}
            </div>

            {/* Mobile search */}
            <div style={{ padding: '16px 24px', borderTop: '1px solid rgba(74,144,226,0.15)' }}>
              <form onSubmit={handleSearchSubmit} style={{ display: 'flex' }}>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={e => setSearchQuery(e?.target?.value)}
                  placeholder="Søk på NordPass..."
                  style={{
                    flex: 1,
                    background: 'rgba(74,144,226,0.06)',
                    border: '1.5px solid rgba(74,144,226,0.25)',
                    borderRight: 'none',
                    padding: '10px 14px',
                    fontFamily: "'Inter', sans-serif",
                    fontSize: '13px',
                    color: '#EEF0F2',
                    outline: 'none'
                  }}
                />
                <button
                  type="submit"
                  style={{
                    background: '#F5A623',
                    border: '1.5px solid #F5A623',
                    padding: '10px 14px',
                    cursor: 'pointer',
                    color: '#0D1929',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  className="btn-spring"
                >
                  <SearchIcon size={16} />
                </button>
              </form>
            </div>

            {/* Bottom accent */}
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0,
              padding: '20px 24px',
              borderTop: '1px solid rgba(74,144,226,0.1)'
            }}>
              <div style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '10px',
                color: 'rgba(238,240,242,0.2)',
                letterSpacing: '1.5px',
                textTransform: 'uppercase'
              }}>© 2024 NordPass AS</div>
            </div>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;